// Topic images copied from the separate Heartport Expert project
// (expert-frontend/src/assets/images/topic_images) - that project picks one
// at random per PubMedCard/ArticleCard purely for decoration (not tied to
// the article's real topic), so this mirrors the same require.context +
// random-pick approach rather than reproducing any per-topic logic.
let cachedImageContext = null;

const loadTopicImagesContext = () => {
  if (cachedImageContext) return cachedImageContext;
  cachedImageContext = require.context('../assets/images/topic_images', false, /\.(jpg|jpeg|png)$/i);
  return cachedImageContext;
};

export const getRandomTopicImage = () => {
  try {
    const context = loadTopicImagesContext();
    const keys = context.keys();
    if (keys.length === 0) return null;
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    return context(randomKey);
  } catch (e) {
    return null;
  }
};
